import { styled, Box } from '@mui/material';
import { rem } from '@core-web/typography';

interface IWrapper {
  /**
   * THe width of the wrapper
   */
  width?: string;

  /**
   * The gap of the wrapper
   */
  gap?: number;
}

export const Wrapper = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'width' && prop !== 'addTopSeparator' && prop !== 'addBottomSeparator' && prop !== 'gap',
})<IWrapper>(({ width, gap }) => ({
  display: 'flex',
  columnGap: rem(gap || 24),
  justifyContent: 'space-between',

  ...(width && {
    width: width,
  }),
}));

export const VerticalStack = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
}));
